module.exports = __webpack_public_path__ + "images/growth-inst1.png";